// Implements: F-MCK-001, F-UIX-008, F-UIX-009, F-UIX-007
/**
 * The refusal of a creation. Pure presentation.
 *
 * Its one action CLOSES the notice. It never offers to try again: creating is
 * not idempotent and may ask a model for a name, so nothing is resent unless
 * the person presses the submit button again, with their text still in place.
 */

import type { ReactElement } from "react";

import { useTranslation } from "../../../shared/i18n";
import { Button } from "../../../shared/ui/atoms/Button";
import styles from "./MockupCreateNotice.module.css";

export interface MockupCreateNoticeProps {
  readonly message: string;
  readonly onClose: () => void;
}

export function MockupCreateNotice({ message, onClose }: MockupCreateNoticeProps): ReactElement {
  const { t } = useTranslation();

  return (
    <div className={styles.notice} role="alert">
      <p className={styles.message}>{message}</p>
      <Button variant="ghost" size="sm" onClick={onClose}>
        {t("common.action.close")}
      </Button>
    </div>
  );
}
